/**
* @ngdoc directive
* @name Drag And Drop
*
* @description
  Show draggable icon
*
* @attributes
* @param {Boolean} isDraggable - show / hide icon
*
* @example
  <drag-drop is-draggable="true"></drag-drop>
*/

(function() {

app.directive('dragDrop', dragDrop);

function dragDrop () {
  var directive = {
    restrict: 'E',
    template: '<span ng-if="isDraggable" as-sortable-item-handle title="Drag and Drop to reorder"' +
              'class="drag-drop visible-hover"><span class="drag-drop-icon"></span></span>' +
              '<span ng-if="!isDraggable" class="drag-drop"></span>' +
              '&nbsp;',
    link: link
  };

  return directive;

  function link($scope, $element, $attributes) {
    $scope.isDraggable = $attributes['isDraggable'] === 'true';
    $attributes.$observe('isDraggable', function(value) {
      $scope.isDraggable = value === 'true';
    });
  }
}

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/dragdropIconDirective.js